import React, { ReactNode } from 'react'

import { Timeline } from 'antd'

interface TimelineProps {
  items: TimelineItemProps[]
  mode?: 'left' | 'right' | 'alternate'
}

interface TimelineItemProps {
  item: string | ReactNode
  icon?: string | ReactNode
}

const Display = (props: TimelineProps) => {
  const children = props.items.map((child, index) => {
    return (
      <Timeline.Item color="#11D175" dot={child.icon} key={index}>
        {child.item}
      </Timeline.Item>
    )
  })

  return <Timeline mode={props.mode}>{children}</Timeline>
}

export default Display
